import { Masterdata, MasterdataAService } from "../../../services";

interface IResolve {
    item: Masterdata
}

class MasterdataEditController implements ng.IComponentController {
    item: Masterdata;

    private resolve: IResolve;
    private type: string = null;

    constructor( private $stateParams: ng.ui.IStateParamsService, private MasterdataAService: MasterdataAService, private $state: ng.ui.IStateService) {
        'ngInject';
    }

    public $onInit = () => {
        this.type = this.$stateParams['type'];
        this.item = this.resolve.item;
        if(!this.type){
            alert('No type given!');
        }
    }

    public save = () => {
        this.item.type = this.type;
        if(!this.item.id){
            this.MasterdataAService.postItem(this.type, this.item).then(() => {
                this.$state.go('^', null, {'reload': true})
            })
        } else {
             this.MasterdataAService.put(this.item.id, this.item).then(() => {
                this.$state.go('^', null, {'reload': true})
            })
        }
    }

    public delete = () => {
        this.MasterdataAService.delete(this.item.id).then(() => {
             this.$state.go('^', null, {'reload': true})
        })
    }
}

export const masterdataEditComponent: ng.IComponentOptions = {
    bindings: {
        resolve: "<"
    },
    controller: MasterdataEditController,
    template: require('./masterdata.edit.html')
}


// WEBPACK FOOTER //
// ./src/app/modules/settings/masterdata/masterdata.edit.component.ts